<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择维修人员"
      width="80%"
      top="5vh">
    <el-table :data="dealMan">
      <el-table-column prop="dealMan" align="center" label="名称"/>
      <el-table-column label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-button size="mini" type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name:"RepairManSelect",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        index: "",
        dealMan:[
          {id: 1,dealMan: "张峰"},
          {id: 2,dealMan: "吴伟龙"},
          {id: 3,dealMan: "金鸣华"},
          {id: 4,dealMan: "范晓华"},
        ],
      };
    },
    methods: {
      open(index) {
        this.index = index;
        this.dialogVisible = true;
      },
      onSelect(row) {
        row.index =  this.index;
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
